import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/orders`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  reminderEmail({commit}, payload: {orderId: any}) {
    return axiosInstance.put(baseUrl + "/" + payload.orderId + "/reminderEmail")
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
